<template>
  <div id="programs">
    <div class="container" >
      <ProgramsComponent />
    </div>
  </div>
</template>

<script>
import InfoBlock from "../modules/InfoBlock";
import ProgramsComponent from "../components/event/Programs.vue";
import $ from "jquery"

export default {
  name: "programs",
  components: { ProgramsComponent, InfoBlock },
  methods: {},
  mounted() {
      $("html, body").animate({ scrollTop: 0 }, 350);
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
  }
};
</script>

<style lang="less">
#programs {
  background-color: #f1f3f6;
  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}

@media (max-width: 768px) {
  #programs {
    padding: 0px;
    padding-bottom: 60px;
    .container {
      padding: 0px 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Programs.vue